'use client';

import { PaginationV2 } from '@pickleballinc/react-ui';
import { useRouter, useSearchParams } from 'next/navigation';

import { ALL_MODULES_PAGE_SIZE } from '@/modules/players/v2/tabs/constants';

interface PaginationWrapperProps {
  totalRecords?: number;
  pageSize?: number;
  scrollToTop?: boolean;
}

export const PaginationWrapper = ({
  totalRecords = 0,
  pageSize = ALL_MODULES_PAGE_SIZE,
  scrollToTop = false,
}: PaginationWrapperProps) => {
  const router = useRouter();
  const searchParams = useSearchParams();
  const currentPage = +(searchParams?.get('current_page') || '1');

  const handlePageChange = (newPage: number) => {
    const newSearchParams = new URLSearchParams(searchParams || '');
    newSearchParams.set('current_page', newPage.toString());
    router.replace(`?${newSearchParams.toString()}`, {
      scroll: scrollToTop,
    });
  };

  return (
    <div className='mt-8 border-t pt-2.5 sm:mt-16 sm:pt-5'>
      <PaginationV2
        currentPage={currentPage}
        totalNumberOfPages={Math.ceil(totalRecords / pageSize)}
        onPreviousClick={() => handlePageChange(currentPage - 1)}
        onNextClick={() => handlePageChange(currentPage + 1)}
        onPageClick={(newPage) => handlePageChange(newPage)}
      />
    </div>
  );
};
